export const actionFactory = (config) => {
  return Object.keys(config).reduce((a, k) => {
    a[k] = (...e) => Object.assign(config[k](...e), { type: k });
    return a;
  }, {});
};

export const Actions: any = actionFactory({
  setAssetLibrary: (assetLibrary) => ({ assetLibrary }),
  setDesign: (design) => ({ design }),
  setActiveGroup: (index) => ({ index }),
  addFace: (config) => ({ config }),
  removeFace: (face) => ({ face }),
  setFaceSize: (face, width, height) => ({ face, width, height }),
  selectFace: (face) => ({ face }),
  selectElement: (face, id) => ({ face, id }),
  selectElements: (face, ids) => ({ face, ids }),
  selectNone: () => ({}),
  updateSelectedElement: (face, data) => ({ face, data }),
  setElement: (face, id, data) => ({ face, id, data }),
  positionElement: (face, id, data) => ({ face, id, data }),
  positionElements: (face, elements) => ({ face, elements }),
  removeElement: (face, id) => ({ face, id }),
  removeElements: (face, ids) => ({ face, ids }),
  resetElement: (face, id) => ({ face, id }),
  updateMeta: (face, meta) => ({ face, meta }),
  moveElementForward: (face, id) => ({ face, id }),
  moveElementBack: (face, id) => ({ face, id }),
});
